import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../views/Layout.vue'
import Login from '../views/Login.vue'
import { getToken, clearToken, setToken } from '@/utils'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: { guestOnly: true }, // 仅未登录用户可访问
  },
  {
    path: '/layout',
    name: 'layout',
    component: Layout,
    meta: { requiresAuth: true }, // 需要登录才能访问
    redirect: '/deviceList',
    children: [
      // 设备管理 deviceManage
      {
        path: '/deviceList',
        name: 'deviceList',
        title: "设备列表",
        component: () => import('@/views/DeviceManage/deviceList.vue'),
      },
      {
        path: '/deviceCheck/:id',
        name: 'deviceCheck',
        title: "柜格列表",
        meta: {
          activeMenu: '/deviceList'
        },
        component: () => import('@/views/DeviceManage/deviceCheck.vue')
      },
      {
        path: '/checkList',
        name: 'checkList',
        title: "柜格列表",
        component: () => import('@/views/DeviceManage/checkList.vue')
      },
      {
        path: '/deviceAreaList',
        name: 'deviceAreaList',
        title: "区域列表",
        component: () => import('@/views/DeviceManage/deviceAreaList.vue')
      },
      {
        path: '/doorOpeningRecord',
        name: 'doorOpeningRecord',
        title: "开门记录",
        component: () => import('@/views/DeviceManage/doorOpeningRecord.vue')
      },
      // 用户管理 userManage
      {
        path: '/userList',
        name: 'userList',
        title: "用户列表",
        component: () => import('@/views/UserManage/userList.vue')
      },
      {
        path: '/userBindClothing/:id',
        name: 'userBindClothing',
        title: "用户衣物列表",
        meta: {
          activeMenu: '/userList'
        },
        component: () => import('@/views/UserManage/userBindClothing.vue')
      },
      // 报警管理 alarmManage
      {
        path: '/deviceFailure',
        name: 'deviceFailure',
        title: "设备故障",
        component: () => import('@/views/AlarmManage/deviceFailure.vue')
      },
      {
        path: '/inventoryAlarm',
        name: 'inventoryAlarm',
        title: "库存告警",
        component: () => import('@/views/AlarmManage/inventoryAlarm.vue')
      },
      {
        path: '/fullbucketAlarm',
        name: 'fullbucketAlarm',
        title: "满桶告警",
        component: () => import('@/views/AlarmManage/fullbucketAlarm.vue')
      },
      {
        path: '/timeoutAlarm',
        name: 'timeoutAlarm',
        title: "超时告警",
        component: () => import('@/views/AlarmManage/timeoutAlarm.vue')
      },
      {
        path: '/alarmNotification',
        name: 'alarmNotification',
        title: "报警通知",
        component: () => import('@/views/AlarmManage/alarmNotification.vue')
      },
      // 衣物管理 clothingManage
      {
        path: '/clothingClassify',
        name: 'clothingClassify',
        title: "衣物分类",
        component: () => import('@/views/ClothingManage/clothingClassify.vue')
      },
      {
        path: '/clothingList',
        name: 'clothingList',
        title: "衣物列表",
        component: () => import('@/views/ClothingManage/clothingList.vue')
      },
      {
        path: '/clothingInventory',
        name: 'clothingInventory',
        title: "衣物库存",
        component: () => import('@/views/ClothingManage/clothingInventory.vue')
      },
      {
        path: '/clothingSpecification',
        name: 'clothingSpecification',
        title: "衣物规格",
        component: () => import('@/views/ClothingManage/clothingSpecification.vue')
      },
      {
        path: '/clothingType',
        name: 'clothingType',
        title: "衣物种类",
        component: () => import('@/views/ClothingManage/clothingType.vue')
      },

      // 记录管理 recordsManage
      {
        path: '/allrecord',
        name: 'allRecord',
        title: "全部记录",
        component: () => import('@/views/RecordsManage/allRecord.vue')
      },
      {
        path: '/inboundRecord',
        name: 'inboundRecord',
        title: "入库记录",
        component: () => import('@/views/RecordsManage/inboundRecord.vue')
      },
      {
        path: '/outboundRecord',
        name: 'outboundRecord',
        title: "出库记录",
        component: () => import('@/views/RecordsManage/outboundRecord.vue')
      },
      {
        path: '/receiveRecord',
        name: 'receiveRecord',
        title: "领取记录",
        component: () => import('@/views/RecordsManage/receiveRecord.vue')
      },
      {
        path: '/recyclingRecord',
        name: 'recyclingRecord',
        title: "回收记录",
        component: () => import('@/views/RecordsManage/recyclingRecord.vue')
      },
      {
        path: '/storageRecord',
        name: 'storageRecord',
        title: "投递记录",
        component: () => import('@/views/RecordsManage/storageRecord.vue')
      },
      {
        path: '/releaseRecord',
        name: 'releaseRecord',
        title: "释放记录",
        component: () => import('@/views/RecordsManage/releaseRecord.vue')
      },
      {
        path: '/statisticalReport',
        name: 'statisticalReport',
        title: "统计报表",
        component: () => import('@/views/RecordsManage/statisticalReport.vue')
      },
      // 工单管理 sheetManage
      {
        path: '/outWorkSheet',
        name: 'outWorkSheet',
        title: "领取工单",
        component: () => import('@/views/SheetManage/outWorkSheet.vue')
      },
      {
        path: '/inWorkSheet',
        name: 'inWorkSheet',
        title: "上架工单",
        component: () => import('@/views/SheetManage/inWorkSheet.vue')
      },
      {
        path: '/workOrderOut/:id',
        name: 'workOrderOut',
        title: "领取工单-详情列表",
        meta: {
          activeMenu: '/outWorkSheet'
        },
        component: () => import('@/views/SheetManage/workOrderOut.vue')
      },
      {
        path: '/workOrderIn/:id',
        name: 'workOrderIn',
        title: "上架工单-详情列表",
        meta: {
          activeMenu: '/inWorkSheet'
        },
        component: () => import('@/views/SheetManage/workOrderIn.vue')
      },
      // 盘点管理 inventoryManage 
      {
        path: '/inventoryRecord',
        name: 'inventoryRecord',
        title: "盘点记录",
        component: () => import('@/views/InventoryManage/inventoryRecord.vue')
      },
      {
        path: '/inventoryRecordDetail/:id',
        name: 'inventoryRecordDetail',
        title: "盘点记录详情",
        meta: {
          activeMenu: '/inventoryRecord'
        },
        component: () => import('@/views/InventoryManage/inventoryRecordDetail.vue')
      },
      {
        path: '/inventoryTime',
        name: 'inventoryTime',
        title: "盘点时间",
        component: () => import('@/views/InventoryManage/inventoryTime.vue')
      },
      // 预警管理 warningManage
      {
        path: '/inventoryWarning',
        name: 'inventoryWarning',
        title: "库存预警",
        component: () => import('@/views/WarningManage/inventoryWarning.vue')
      },
      // 广告管理 advertManage 
      {
        path: '/advertSort',
        name: 'advertSort',
        title: "广告分类",
        component: () => import('@/views/AdvertManage/advertSort.vue')
      },
      {
        path: '/advertList',
        name: 'advertList',
        title: "广告列表",
        component: () => import('@/views/AdvertManage/advertList.vue')
      },
      {
        path: '/playList',
        name: 'playList',
        title: "广告播放",
        component: () => import('@/views/AdvertManage/advertPlay.vue')
      },
      {
        path: '/advertPlayList/:id',
        name: 'advertPlayList',
        title: "广告播放列表",
        meta: {
          activeMenu: '/playList'
        },
        component: () => import('@/views/AdvertManage/advertPlayList.vue')
      },
      // 系统管理 systemManage
      {
        path: '/systemUser',
        name: 'systemUser',
        title: "用户管理",
        component: () => import('@/views/SystemManage/systemUser.vue')
      },
      {
        path: '/systemRole',
        name: 'systemRole',
        title: "角色管理",
        component: () => import('@/views/SystemManage/systemRole.vue')
      },
      {
        path: '/systemAuthority',
        name: 'systemAuthority',
        title: "权限管理",
        component: () => import('@/views/SystemManage/systemAuthority.vue')
      },
      {
        path: '/systemMenu',
        name: 'systemMenu',
        title: "菜单管理",
        component: () => import('@/views/SystemManage/systemMenu.vue')
      },
      {
        path: '/systemDepart',
        name: 'systemDepart',
        title: "部门管理",
        component: () => import('@/views/SystemManage/systemDepart.vue')
      },
      {
        path: '/systemEnterprise',
        name: 'systemEnterprise',
        title: "企业管理",
        component: () => import('@/views/SystemManage/systemEnterprise.vue')
      },
      {
        path: '/systemLog',
        name: 'systemLog',
        title: "操作日志",
        component: () => import('@/views/SystemManage/systemLog.vue')
      },
      {
        path: '/systemParameterConfig',
        name: 'systemParameterConfig',
        title: "参数配置",
        component: () => import('@/views/SystemManage/systemParameterConfig.vue')
      },
    ]
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    // meta: { requiresAuth: true }, // 需要登录才能访问
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/ErrorPage/error404.vue')
  },
  {
    path: '/:pathMatch(.*)*', // 必须使用这个特殊语法
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = getToken() // 检查是否登录
  // 如果目标路由需要登录，但用户未登录，则跳转登录页
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/')
  }
  // 如果目标路由仅限未登录用户（如登录页），但用户已登录，则跳转首页
  else if (to.meta.guestOnly && isLoggedIn) {
    next('/layout')
  }
  // 否则正常访问
  else {
    next()
  }
})
export default router
